// endpoints.js
import axios from "axios";
import { getApiUrl } from "../utils/envConfig";
import {
  validateSecurityHeaders,
  getApiSecurityHeaders,
} from "../config/securityHeaders";
import { getAuthToken, refreshAuthToken } from "../utils/authUtils";

// Enhanced axios utility with token management and retry logic
const makeAuthenticatedRequest = async (url, options = {}, retries = 3) => {
  try {
    // Always ensure we have a valid token before making the request
    const token = await getAuthToken();

    const headers = {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
      ...getApiSecurityHeaders(), // Add security headers
      ...options.headers,
    };

    const requestConfig = {
      url,
      headers,
      method: options.method || "GET",
      ...options,
    };

    // Handle data/body for axios
    if (options.body) {
      requestConfig.data = JSON.parse(options.body);
      delete requestConfig.body;
    }

    const response = await axios(requestConfig);

    // Validate security headers in development
    if (import.meta.env.VITE_ENVIRONMENT === "development") {
      validateSecurityHeaders(response);
    }

    return response.data;
  } catch {
    if (retries <= 0) {
      throw new Error("Max retries reached. Could not complete the request.");
    }

    // Try to refresh token and retry
    try {
      await refreshAuthToken();
      // Retry the request with the new token
      return await makeAuthenticatedRequest(url, options, retries - 1);
    } catch (tokenError) {
      throw new Error("Failed to refresh token: " + tokenError.message);
    }
  }
};

// Fetch companies with brands data
export const getCompaniesWithBrands = async ({ id_client, country }) => {
  try {
    const url = `${getApiUrl()}/client/${id_client}/country/${country}/brands/tree`;
    const data = await makeAuthenticatedRequest(url);
    return data;
  } catch (error) {
    console.error("[endpoints] Error fetching companies with brands:", error);
    throw new Error("Failed to fetch companies with brands: " + error.message);
  }
};

export const fetchMockData = () => {
  // Simulated API latency
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          key: "pepsi",
          label: "Pepsi",
          amount: 12500,
          pie_percent: "40%",
          food_percent: "35%",
          img_percent: "25%",
        },
        {
          key: "coca_cola",
          label: "Coca-Cola",
          amount: 15000,
          pie_percent: "50%",
          food_percent: "30%",
          img_percent: "20%",
        },
        {
          key: "sprite",
          label: "Sprite 1231231asdasdasdasdwdqwdqwdasdasdasdwdqwdqww",
          amount: 9200,
          pie_percent: "30%",
          food_percent: "50%",
          img_percent: "20%",
        },
        {
          key: "fanta",
          label: "Fanta",
          amount: 8700,
          pie_percent: "25%",
          food_percent: "55%",
          img_percent: "20%",
        },
        {
          key: "red_bull",
          label: "Red Bull asdasdqwdqwdasdasdzxzxcawqwdasdasdzxcawd",
          amount: 10300,
          pie_percent: "40%",
          food_percent: "35%",
          img_percent: "25%",
        },
        {
          key: "red_bull1",
          label: "Red Bull asdasdqwdqwdasdasdzxzxcawqwdasdasdzxcawd",
          amount: 10300,
          pie_percent: "40%",
          food_percent: "35%",
          img_percent: "25%",
        },
        {
          key: "red_bull2",
          label: "Red Bull asdasdqwdqwdasdasdzxzxcawqwdasdasdzxcawd",
          amount: 10300,
          pie_percent: "40%",
          food_percent: "35%",
          img_percent: "25%",
        },
      ]);
    }, 500);
  });
};

